import { withTranslation } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import {
  Extra,
  FooterRow,
  FooterLinks,
  FooterLink,
  FooterExternalLink,
  SocialRow,
  Copyright,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
  label: string;
}

const Footer = () => {
  const SocialLink = ({ href, src, label }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={label}
        title={label}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <Extra>
      <Container>
        <FooterRow>
          <FooterLinks>
            <FooterLink to="/">Terms &amp; Privacy</FooterLink>
            <FooterLink to="/HostingServer">Hosting</FooterLink>
            <FooterLink to="/Subscriptions">Subscriptions</FooterLink>
            <FooterExternalLink href="mailto:gameplier.team@gmail.com">
              Contact
            </FooterExternalLink>
          </FooterLinks>
          <SocialRow>
            <SocialLink
              href="https://www.facebook.com/Gameplier"
              src="facebook.png"
              label="Facebook"
            />
            <SocialLink
              href="https://discord.gg/HwVzkMWrxH"
              src="discord.png"
              label="Discord"
            />
            <SocialLink
              href="https://play.google.com/store/apps/details?id=com.gameplier.kontra"
              src="google_play.png"
              label="Google Play"
            />
            <SocialLink
              href="https://apps.apple.com/us/app/kontra-multiplayer-fps/id1660215198"
              src="app_store.png"
              label="App Store"
            />
          </SocialRow>
        </FooterRow>
        <Copyright>
          © {new Date().getFullYear()} Gameplier
        </Copyright>
      </Container>
    </Extra>
  );
};

export default withTranslation()(Footer);
